var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86 86"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2 79.8c1.6-1 2.1-3 1.1-4.6s-3-2.1-4.6-1.1C44.5 84.6 22 79.2 11.5 61.9S6.4 22.1 23.6 11.6s39.8-5.1 50.3 12.1c7.4 12.2 7.1 27.5-.8 39.4-1 1.5-.6 3.6.9 4.7s3.6.6 4.7-.9c13.2-19.7 7.9-46.4-11.8-59.6-17.1-11.4-39.8-9.2-54.3 5.3-16.8 16.8-16.8 44 0 60.8 14 14 35.7 16.6 52.6 6.4",
    fill: "#006e94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9 56.4c0 2.7-2.2 4.9-4.9 4.9s-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9zM43 46.7c-2.7 0-4.9-2.2-4.9-4.9V27.1c0-2.7 2.2-4.9 4.9-4.9s4.9 2.2 4.9 4.9v14.7c0 2.7-2.2 4.9-4.9 4.9z",
    fill: "#f8a826"
  })));
}
export default SvgPopupWarning;